import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'

export const messages = {
  en: {
    ...enLocale,
    login: {
      brand: 'Wufang Property Steward',
      platformTitle: 'Smart Property Management Platform',
      platformSlogan: 'Secure Login · Efficient Operations',
      adminTitle: 'Admin Login',
      title: 'WF Smart Community',
      username: 'Account',
      password: 'Password',
      captcha: 'Verification Code',
      login: 'Login',
      reset: 'Reset',
      usernamePlaceholder: 'Account',
      passwordPlaceholder: 'Password',
      captchaPlaceholder: 'Verification Code',
      loginFailed: 'Login failed, please try again',
      getCaptchaFailed: 'Failed to get verification code',
      storeName: 'store name',
      relCdName: 'role'
    }
  },
  zh: {
    ...zhLocale,
    login: {
      brand: '武房物业管家',
      platformTitle: '智慧物业管理平台',
      platformSlogan: '安全登录 · 高效运维',
      adminTitle: '管理员登录',
      title: '武房智慧社区',
      username: '账号',
      password: '密码',
      captcha: '验证码',
      login: '登录系统',
      reset: '重置',
      usernamePlaceholder: '账号',
      passwordPlaceholder: '密码',
      captchaPlaceholder: '验证码',
      loginFailed: '登录失败，请重试',
      getCaptchaFailed: '获取验证码失败',
      storeName: '公司名称',
      relCdName: '角色'
    }
  },
  'zh-TW': {
    ...zhLocale,
    login: {
      brand: '武房物業管家',
      platformTitle: '智慧物業管理平台',
      platformSlogan: '安全登錄 · 高效運維',
      adminTitle: '管理員登錄',
      title: '武房智慧社區',
      username: '帳號',
      password: '密碼',
      captcha: '驗證碼',
      login: '登錄系統',
      reset: '重置',
      usernamePlaceholder: '帳號',
      passwordPlaceholder: '密碼',
      captchaPlaceholder: '驗證碼',
      loginFailed: '登錄失敗，請重試',
      getCaptchaFailed: '獲取驗證碼失敗',
      storeName: '公司名稱',
      relCdName: '角色'
    }
  }
}
